$(document).ready(function () {
    $('#emailphone').on('keyup', function() {
        $('#error-email').html('');
        $("#alert").css('display','none')
    })
    $("#emailphone").on('blur' , function() {

        let reg = /^([a-zA-Z0-9])+@yahoo.com/;
        let _valEmail = $('#emailphone').val();
        if ( _valEmail.match(reg) ) {
            $("#yahoovalidation").css('display', 'block');
            $("#yahoovalidation").parents('#messsage-login').addClass('login-right-errorbox');

        }
    });
    var flag=false;
    //when use click sift key then allow to register
    $( '#reg-btn-create-account, input' ).on( 'click keydown',  function ( event ) {
        if( ( event.type == 'click' && event.shiftKey )
            || ( event.type == 'keydown' && event.which  == 13 && event.shiftKey) ) {
            flag=true;
            $("#form-registration" ).submit();
        };
    } );
    $("#form-registration" ).submit(function( event ) {
        const emailphone = $.trim($('#emailphone').val());
        //const phone = $.trim($('#phone').val());
        console.log("flag===",flag)
        let error = false;
        if(!emailphone ) {
            error = true;
            $('#emailphone').focus();
        }
        if(emailphone) {
            if(!validateEmail(emailphone) && !validatePhone(emailphone) ) {
              error = true;
              $('#error-email').html('Invalid phone or email address');
            } else {
                if(checkYahoo(emailphone) && !validatePhone(emailphone) &&  flag==false){
                    $("#yahoovalidation").css('display', 'block');
                    $("#yahoovalidation").parents('#messsage-login').addClass('login-right-errorbox');
                    document.getElementById("emailphone").focus();
                    error = true;
                }
            }
        }
        if(error) {
            event.preventDefault();
        } else {
          const exprieTime = new Date();
          exprieTime.setTime(exprieTime.getTime() + 24*60*60*1000);
          const timeRegister = new Date();
          const register = JSON.stringify({
            timeRegister,
            email,
          });
          document.cookie = `register=${register};expires=${exprieTime};path=/`;
        }
    });
    $('#code-confirm').on('keyup keypress blur change paste', function() {
        let confirm = $(this);
        setTimeout(function(){
            $('#alert-valid-code').hide().find('p').html('');
            let  value = confirm.val();
            if(value && value.length === 4) {
                $('#btn-confirm').prop('disabled',  false);
            } else {
                $('#btn-confirm').prop('disabled',  true);
            }
        }, 100);
    })

    $('#btn-confirm').on('click', function() {
        const phone = $('#phone-register').val();
        const userId = $('#id-register').val();
        const code = $('#code-confirm').val();
        const linkReset = $('#link-reset').val();
        $('#btn-confirm').prop('disabled', true);
        if(code && code.length === 4) {
            $.ajax({
                url: '/users/confirm/code',
                method: 'POST',
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({ code: code, phone: phone, userId: userId }),
                success : function(data) {
                    if(data && data.success && data.link) {
                        if(linkReset) {
                            window.location.href = linkReset;
                        } else {
                            window.location.href = data.link;
                        }
                    } else {
                        $('#alert-valid-code').show().find('p').html(data.message || 'Code not corret!');
                    }
                    $('#btn-confirm').prop('disabled', false);
                },
                error: function(error){
                    console.error(error)
                }
            })
        } else {
            $('#btn-confirm').prop('disabled', false);
            $('#alert-valid-code').show().find('p').html('Code not exists');
        }
    })

    $('#btn-send-to').on('click', function() {
        $('#btn-send-to').html('<i class="fa fa-spinner fa-spin fa-fw"></i>');
        $('#btn-send-to').prop('disabled', true);
        const linkReset = $('#link-reset').val() ? true : '';
        const phone = $('#phone-register').val();
        const userId = $('#id-register').val();

        if(phone) {
            $.ajax({
                url: '/users/confirm/reset',
                method: 'POST',
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({ phone: phone, registration: linkReset, userId: userId }),
                success : function(data) {
                    if(data && data.success) {
                        toastr.success(data.message);
                    } else {
                        toastr.error(data.message || `We cannot send sms to phone number ${phone}`);
                    }
                    $('#btn-send-to').html('send again');
                    $('#btn-send-to').prop('disabled', false);
                },
                error: function(error){
                    console.error(error)
                    $('#btn-send-to').html('send again');
                    $('#btn-send-to').prop('disabled', false);
                    toastr.error("We couldn't send to the server!");
                }
            })
        }
    })
    
  var loginFacebook = document.getElementById('btn-login-facebook');
  var loginGoogle = document.getElementById('btn-login-google');
  
  var check_iOSapp = function check_iOSapp() { return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)) ? true : false; };
  var check_androidApp = function check_androidApp() { return (window.navigator.userAgent == 'PlateRateForAndroid'); };
  if(loginFacebook) loginFacebook.onclick = function() {

    var dataRegisterFB= $(loginFacebook).attr('data-account');
    console.log("dataRegisterFB=====", dataRegisterFB);
    localStorage.setItem('dataRegisterFB', dataRegisterFB);

      var redirectto =  setLoginRedirectTo('facebook'); 
    
    console.log("login with fb redirect to...", redirectto);
      if (check_iOSapp() || check_androidApp()) {
        window.location = "plateratewebtonative:loginFacebook";
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        if(redirectto && redirectto.includes('&buymenuitemid')){
           redirectto = redirectto.replace("&buymenuitemid", "?buymenuitemid");
        }
        if(redirectto && redirectto.includes('register')){
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'user-signup-submit',
            eventProps: {
              category: 'account',
              action: 'user-signup-submit',
              label: 'facebook', // put here the platform chosen by the user 
              value: 1
            }
          });
        }else{
          window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            event: 'user-signin-submit',
              eventProps: {
                category: 'account',
                action: 'user-signin-submit',
                label: 'facebook', 
                value: 1
              }
            });
        }
        
        window.location.href = '/users/login/facebook' + (redirectto ? window.location.search :"?next=/");
      }
  }
  if(loginGoogle)  loginGoogle.onclick = function() {
    var dataRegisterGoogle= $(loginGoogle).attr('data-account');
    console.log("dataRegisterGoogle=====", dataRegisterGoogle);
    localStorage.setItem('dataRegisterGoogle', dataRegisterGoogle);

      var redirectto =  setLoginRedirectTo('google'); 
    
      if (check_iOSapp() || check_androidApp()) {
        window.location = "plateratewebtonative:loginGoogle";
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        if(redirectto && redirectto.includes('&buymenuitemid')){
           redirectto = redirectto.replace("&buymenuitemid", "?buymenuitemid");
        }
        if(redirectto && redirectto.includes('register')){
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'user-signup-submit',
            eventProps: {
              category: 'account',
              action: 'user-signup-submit',
              label: 'google', // put here the platform chosen by the user 
              value: 1
            }
          });
        }else{
          window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            event: 'user-signin-submit',
              eventProps: {
                category: 'account',
                action: 'user-signin-submit',
                label: 'google',   
                value: 1
              }
            });
        }

        console.log("login google click, next=", redirectto);
       
        window.location.href = '/users/login/google' + (redirectto ? window.location.search+"#_#_" :"?next=/#_#_");
      }
  }

})
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function validatePhone(phone) {
    let regexUSPhoneNumber = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
    return regexUSPhoneNumber.test(phone)
}
function checkYahoo(email) {
    var re = /^[^@]+@(yahoo|ymail|rocketmail)\.com$/i;
    return re.test(email);
}

function setLoginRedirectTo(flag){
  let userId = $('#userId').val();
  console.log(userId, 'userId=======')

  let searchParams = new URLSearchParams(window.location.search);
  let current_url = window.location.pathname;
  console.log("in setRedirectTo...searchparams...", searchParams, current_url);
  if(searchParams && searchParams.has('emailphone')) {
    let email = searchParams.get('emailphone');
    if(document.getElementById("emailphone")) document.getElementById("emailphone").value = email;
  }
  let redirectto = null;
  let buymenuitemid = null;
  let tab=null;
  let buymenuitemquantity = null;
  let referrerId= null;
  if(searchParams && searchParams.has('next')) {
    redirectto = searchParams.get('next');
    buymenuitemid = searchParams.get('buymenuitemid');
    buymenuitemquantity = searchParams.get('buymenuitemquantity');
    referrerId = searchParams.get('referrerId');
    tab = searchParams.get('tab');
    console.log("buymenuitemid redirect being set in users.js...", redirectto, buymenuitemid, tab, searchParams);
    if(redirectto && redirectto != "null" ){ /* next=null will return "null" */
      redirectto = redirectto.trim();
      if(buymenuitemid){
          redirectto += `&buymenuitemid=${buymenuitemid}`;
          if(localStorage) localStorage.setItem('buymenuitemid', buymenuitemid);
      } else if(localStorage){
          let cmenuitemid = localStorage.getItem('buymenuitemid');
          if(cmenuitemid) {
            console.log("found localStorage...", cmenuitemid);
            buymenuitemid = cmenuitemid;
          }
        }
      }
      if(buymenuitemquantity){
          redirectto += `&buymenuitemquantity=${buymenuitemquantity}`;
          if(localStorage) localStorage.setItem('buymenuitemquantity', buymenuitemquantity);
	    } else if(localStorage){
          let cbuymenuitemquantity = localStorage.getItem('buymenuitemquantity');
          if(cbuymenuitemquantity) {
            console.log("found localStorage buymenuitemquantity...", cbuymenuitemquantity);
            buymenuitemquantity = cbuymenuitemquantity;
          }
      }
      
      if(tab){
          redirectto += `&tab=${tab}`;
          if(localStorage) localStorage.setItem('tab', tab);
    	} else if(localStorage){
          let ctab = localStorage.getItem('tab');
          if(ctab) {
            console.log("found localStorage tab...", ctab);
            tab = ctab;
          }
      }
      if(referrerId){
          redirectto += `&referrerId=${referrerId}`;
          if(localStorage) localStorage.setItem('referrerId', referrerId);
	    } else if(localStorage){
          let ctab = localStorage.getItem('referrerId');
          if(ctab) {
            console.log("found localStorage referrerId...", ctab);
            referrerId = ctab;
          }
      }
      $("#redirectTo").val(redirectto);
      if(localStorage && redirectto){
          localStorage.setItem("url_before_logging_in", redirectto);
      }
    } 
  /* check in localstaorage incase user entered wrong email address first time, then next will not work */
   let urlOrderBeforeLogin = localStorage.getItem('urlOrderBeforeLogin');
   let orderedBeforeLogin = localStorage.getItem('orderedBeforeLogin');
   console.log("urlOrderBeforeLogin and orderedBeforeLogin... ",urlOrderBeforeLogin, orderedBeforeLogin);
   console.log("localStorage====",localStorage);
   console.log("redirectto====",redirectto,userId);

    if(localStorage && (!redirectto || redirectto == "null" ) ){
      redirectto = localStorage.getItem("url_before_logging_in");
      console.log("redirect being got in users.js in localStorage...",redirectto);
      if(redirectto && redirectto != "null" ) $("#redirectTo").val(redirectto);
    }else if(typeof (userId) !='undefined'){
        window.location.href=redirectto;
    }

    return redirectto;
}


